import { useSelector } from "react-redux";
import groupByConsecutiveSpeakers from "../../../../services/GroupSegments";
import styles from "./styles.module.scss";
import { Document, Packer, Paragraph, TextRun, HeadingLevel } from "docx";
import { fetchWordpressLink } from "../../../../api/wpApi";

export default function ExportTranscript() {
  const data = useSelector((state) => state.datasetSlice.dataset);

  const handleGroupedSegments = async () => {
    const segments = groupByConsecutiveSpeakers(data.transcript.segments, 1000);
    const title = `${data.title} - ${new Date(
      data.upload_date
    ).toLocaleDateString()}`;

    const reportLink = data.wp_id ? await fetchWordpressLink(data.wp_id) : null;

    const section = {
      properties: {},
      children: [],
    };

    const titleParagraph = new Paragraph({
      children: [
        new TextRun({
          text: title,
          bold: true,
          font: {
            name: "Arial",
            size: 32,
          },
          color: "000000",
        }),
      ],
      heading: HeadingLevel.HEADING_1,
    });

    section.children.push(titleParagraph);

    if (reportLink) {
      const reportLinkParagraph = new Paragraph({
        children: [
          new TextRun({
            text: `${reportLink}`,
            bold: false,
            italics: true,
            font: {
              name: "Arial",
              size: 16,
            },
            color: "000000",
          }),
        ],
      });

      section.children.push(reportLinkParagraph);
    }

    segments.forEach((segment) => {
      const speaker = segment[0].speaker;
      const speakerParagraph = new Paragraph({
        children: [
          new TextRun({
            text: speaker,
            bold: true,
            font: {
              name: "Arial",
              size: 18,
            },
            color: "000000",
            break: 3,
          }),
        ],
        heading: HeadingLevel.HEADING_2,
      });
      section.children.push(speakerParagraph);
      const text = segment.reduce((acc, { text }) => acc + text, "").slice(1);
      const paragraph = new Paragraph({
        children: [
          new TextRun({
            text,
            italics: true,
            bold: false,
            font: {
              name: "Arial",
              size: 16,
            },
            color: "000000",
            break: 1,
          }),
        ],
      });
      section.children.push(paragraph);
    });

    const doc = new Document({
      sections: [section],
    });

    const blob = await Packer.toBlob(doc);
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${new Date(
      data.upload_date
    ).toLocaleDateString()} - Transcript Export.docx`;

    link.click();
  };

  if (!data.transcript.segments.length > 0) {
    return null;
  }

  return (
    <div className={styles.exportTranscriptWrapper}>
      <button
        className={styles.exportButton}
        onClick={() => {
          handleGroupedSegments();
        }}
      >
        Export transcript (.docx)
      </button>
    </div>
  );
}
